import { render } from "./Edit.vue?vue&type=template&id=175a8768&scoped=true&ts=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=175a8768&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175a8768"]])

export default __exports__